import { PosixDate } from "../time/posix-date.js";
export var JSONUtils;
(function (JSONUtils) {
    function reviver(key, value) {
        if (PosixDate.isPosixDateJSON(value)) {
            return PosixDate.fromJson(value);
        }
        return value;
    }
    JSONUtils.reviver = reviver;
    function parse(json) {
        return JSON.parse(json, reviver);
    }
    JSONUtils.parse = parse;
    /**
     * Revive un valor YA parseado (el objeto plano que devuelve el driver para
     * columnas MySQL `json`), rehidratando PosixDate vía el reviver.
     *
     * Para columnas `json` NO hay que stringify/parse a mano: el driver
     * (preparePersistentValue) ya hace `JSON.stringify` al escribir y mysql2
     * devuelve el objeto parseado al leer. Hacerlo manualmente doble-encodea
     * (ver bug de search_features). Acá solo aplicamos el reviver al objeto.
     */
    function revive(value) {
        if (value === null || value === undefined)
            return value;
        return JSON.parse(JSON.stringify(value), reviver);
    }
    JSONUtils.revive = revive;
})(JSONUtils || (JSONUtils = {}));
